export const SizeColumns = [
    "SNo",
    "POSize",
    "CRMSize"
  ]